import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSortDescStyle0 = gravityIconIndividualCss;

const GravityIconSortDesc = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '67bac333475d4d573c8ff35c4c08c6984d26b1bf', color: this.color, size: this.size }, h("svg", { key: 'fac694fb3be4b5346689cfcd543f11cae3763a34', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '20580b683721ae37658c5b25e5c0a8518f50696d', d: "M11.75 14.125h2.284a.4.4 0 0 1 .283.683l-3.034 3.034a.4.4 0 0 1-.566 0l-3.034-3.034a.4.4 0 0 1 .283-.683h2.284v-9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v9.5Z", fill: "currentColor" }))));
    }
};
GravityIconSortDesc.style = GravityIconSortDescStyle0;

export { GravityIconSortDesc as gravity_icon_sort_desc };

//# sourceMappingURL=gravity-icon-sort-desc.entry.js.map